// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Xd","innerTile":"Yd","heading":"Zd","instaTileBtn":"_d","disabled":"ae","instaTileElement":"be","instagramPic":"ce"};